import { render, staticRenderFns } from "./FilesResume.vue?vue&type=template&id=edc3c29a&scoped=true&"
import script from "./FilesResume.vue?vue&type=script&lang=js&"
export * from "./FilesResume.vue?vue&type=script&lang=js&"
import style0 from "./FilesResume.vue?vue&type=style&index=0&id=edc3c29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc3c29a",
  null
  
)

export default component.exports